import output from "_src/engine/output";
import AbstractPacker from "_src/engine/packers/abstract_packer";
import containersCache from "_src/engine/packers/containers_cache";

import {uint32ToUint8Array, arrayDataToNumber} from "_src/utils";

// NOTE: https://confluence.artec-group.com:4432/pages/viewpage.action?pageId=39419976
const DEFAULT_HEADER = [
  "m".charCodeAt(0), "l".charCodeAt(0), "t".charCodeAt(0), "i".charCodeAt(0),
  2, 0,
  0, 0,
];

const SUPPORTED_TYPES = [
  "zstd", "crt", "drc", "jpeg", "png", "mlti",
];

const COMPRESSION_FORMAT_SIZE = 4;
const STRUCTURE_VERSION_SIZE = 2;
const BUFFERS_COUNT_SIZE = 2;
const BUFFER_ID_SIZE = 4;
const BUFFER_FULL_SIZE_SIZE = 4;
const BUFFER_COMPRESSED_SIZE_SIZE = 4;

export default class Slicer extends AbstractPacker {
  packData(buffers) {
    let resultSlice = DEFAULT_HEADER.slice();

    const buffersCountOffset = COMPRESSION_FORMAT_SIZE + STRUCTURE_VERSION_SIZE;
    const buffersCount = buffers.length;
    if (buffersCount >= 256 * 256) {
      throw "Too many chunks in slice";
    }

    const headerSize = (COMPRESSION_FORMAT_SIZE + STRUCTURE_VERSION_SIZE + BUFFERS_COUNT_SIZE);
    const tableEntrySize = (BUFFER_ID_SIZE + BUFFER_COMPRESSED_SIZE_SIZE + BUFFER_FULL_SIZE_SIZE);
    const dataOffset = headerSize + tableEntrySize * buffersCount;

    resultSlice[dataOffset-1] = 0; //reserving table

    const buffersCountData = uint32ToUint8Array(buffersCount);
    resultSlice[buffersCountOffset] = buffersCountData[0];
    resultSlice[buffersCountOffset + 1] = buffersCountData[1];

    for (let i=0; i<buffersCount; i++) {
      const buffer = buffers[i];

      const idData = uint32ToUint8Array(i);
      const bufferSizeData = uint32ToUint8Array(buffer.length);

      const tableEntryOffset = (COMPRESSION_FORMAT_SIZE + STRUCTURE_VERSION_SIZE + BUFFERS_COUNT_SIZE) +
        (BUFFER_ID_SIZE + BUFFER_COMPRESSED_SIZE_SIZE + BUFFER_FULL_SIZE_SIZE) * i;
      const tableEntry = [
        idData[0], idData[1], 0, 0,
        bufferSizeData[0], bufferSizeData[1], bufferSizeData[2], bufferSizeData[3],
        bufferSizeData[0], bufferSizeData[1], bufferSizeData[2], bufferSizeData[3],
      ];
      for (let j=0; j<tableEntry.length; j++) {
        resultSlice[tableEntryOffset + j] = tableEntry[j];
      }

      resultSlice = resultSlice.concat(Array.from(buffer));
    }
    return resultSlice;
  }

  unpackData(slice) {
    let byteOffset = 0;

    byteOffset += COMPRESSION_FORMAT_SIZE;

    const structureVersion = arrayDataToNumber(slice, byteOffset, STRUCTURE_VERSION_SIZE);
    byteOffset += STRUCTURE_VERSION_SIZE;

    const buffersCounter = arrayDataToNumber(slice, byteOffset, BUFFERS_COUNT_SIZE);
    byteOffset += BUFFERS_COUNT_SIZE;

    const buffersData = [];

    if (structureVersion === 2 && SUPPORTED_TYPES.includes(containersCache.getBufferType(slice))) {

      const buffersSizes = [];
      for (let i = 0; i< buffersCounter; i++) {
        byteOffset += BUFFER_ID_SIZE;

        const bufferSize = arrayDataToNumber(slice, byteOffset, BUFFER_FULL_SIZE_SIZE);
        buffersSizes[i] = bufferSize;

        byteOffset += BUFFER_FULL_SIZE_SIZE + BUFFER_COMPRESSED_SIZE_SIZE;
      }

      for (let i = 0; i < buffersCounter; i++) {
        const bufferSize = buffersSizes[i];

        if (byteOffset + bufferSize > slice.byteLength) {
          throw "Can't load invalid slice";
        }

        const bufferData = slice.slice(byteOffset, byteOffset+bufferSize);

        buffersData.push(bufferData);
        byteOffset+=bufferSize;

      }

      if (byteOffset !== slice.byteLength) {
        output.warn("Undefined data in slice after layout");
      }

    } else {

      buffersData.push(slice);

    }

    return buffersData;
  }

}
